import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Breadcrumbs, Loading } from "../../components/shared";
import useCheckLoggedin from "../../utils/useCheckLoggedin";
import { notifyOtpValidatedSession, checkOtpValidatedSession } from "../../service/UserApi";
import { useSelector, useDispatch } from "react-redux";
import { updateUserData } from "../../redux/slice/userSlice";

const UserSessionOTPValidation = () => {
  useCheckLoggedin(); // Check if the user is logged in (if no user data, redirect to login)
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const redirectTo = queryParams.get("from") || "family"; // default to 'family'

  const { register, handleSubmit, formState: { errors } } = useForm();
  const loggedInUserEmail = useSelector((state) => state.user.email);
  const dispatch = useDispatch();

  // ✅ STEP 1: Check session OTP status on component mount
  useEffect(() => {
    const checkOtpSession = async () => {
      setLoading(true);
      try {
        const response = await checkOtpValidatedSession({ email: loggedInUserEmail });

        // If already validated, redirect based on query
        if (response?.otpValidatedSession) {
          dispatch(updateUserData({ otpValidatedSession: true }));
          navigate(`/user/${redirectTo}`);
          return;
        }

        // If not validated, but eligible to send OTP
        if (response?.success) {
          setIsOtpSent(true);
        } else {
          alert(response?.data?.message || "OTP அனுப்புவதில் பிழை.");
          navigate("/user/profile");
        }

      } catch (err) {
        console.error("OTP session check error:", err);
        alert("உள் நிர்வாக பிழை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.");
        navigate("/");
      } finally {
        setLoading(false);
      }
    };

    checkOtpSession();
  }, [loggedInUserEmail, navigate, redirectTo, dispatch]);

  // ✅ STEP 2: Handle OTP submission
  const handleOtpSubmit = async (data) => {
    const { otp } = data;
    setLoading(true);
    setError("");

    try {


      const notifyData = { email: loggedInUserEmail, otp };
      const response = await notifyOtpValidatedSession(notifyData);

      if (response?.otpValidatedSession) {
        dispatch(updateUserData({ otpValidatedSession: true }));
        navigate(`/user/${redirectTo}`);
        return;
      }

      if (!response?.success) {
        if (response?.message === 'OTP தவறானது. மீண்டும் முயற்சிக்கவும்.') {
          setError(response.message);
          return;
        }
        alert(response?.message || "OTP சரிபார்ப்பு தோல்வியடைந்தது.");
        navigate("/");
      }

    } catch (err) {
      console.error("OTP verification error:", err);
      alert("OTP சரிபார்ப்பு பிழை. தயவுசெய்து பின்னர் முயற்சிக்கவும்.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <Helmet>
        <title>ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள் | கைபேசி OTP சரிபார்க்கவும்</title>
      </Helmet>
      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs /><br />

            {isOtpSent ? (
              <form onSubmit={handleSubmit(handleOtpSubmit)} className="auth_form">
                <div className="auth_element">
                  <label className="auth_label">🔐 OTP</label>
                  <input
                    type="text"
                    {...register("otp", {
                      required: "OTP தேவை",
                      pattern: {
                        value: /^[0-9]{6}$/,
                        message: "OTP 6 இலக்கங்களாக இருக்க வேண்டும்.",
                      },
                    })}
                    className="auth_input"
                    autoComplete="one-time-code"
                    maxLength="6"
                    inputMode="numeric"
                  />
                  {errors.otp && <div className="auth_error">{errors.otp.message}</div>}
                  {error && <div className="auth_error">{error}</div>}
                </div>
                <button type="submit" className="auth_submit" disabled={loading}>
                  {loading ? "சமர்ப்பிக்கின்றது..." : "OTP சரிபார்க்கவும்"}
                </button>
              </form>
            ) : (
              <>
                <p>OTP அனுப்பப்படுகிறது ...</p>
                <Loading />
              </>
            )}

            <br />
            <button onClick={() => navigate("/user/profile")}>என் கணக்கிற்குச் செல் 👤</button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UserSessionOTPValidation;
